import { Header } from "@/app/components/LayoutComponents/Header";
import dynamic from "next/dynamic";
import { Contact } from "@/app/components/LayoutComponents/Contact";
import { LayoutFooter } from "@/app/components/LayoutComponents/Footer";
import { useRouter } from "next/router";
import ChatBot from "@/app/components/LayoutComponents/ChatBot";
import ChatManager from "../UI/ChatManager";

interface DefaultLayoutProps {
  children: React.ReactNode;
  contents?: string[];
  title_contents?: string[];
}

export default function DefaultLayout({
  children,
  contents,
  title_contents,
}: DefaultLayoutProps) {
  const { asPath } = useRouter();
  const pathname = asPath.split("?")[0];

  const isCMS = pathname?.includes("cms");
  const isTouchpoint = pathname?.includes("touchpoint");
  const isPosVenda = pathname?.includes("pos-venda");
  const isAgendamento = pathname?.includes("agendamento");
  const isPecas = pathname?.includes("/servicos/pecas");

  const DynamicAccordion = dynamic(() => import("./Accordion"));

  return (
    <>
      {isCMS || isTouchpoint ? (
        children
      ) : (
        <div>
          <Header />
          {children}
          <Contact />
          <LayoutFooter />
          {!isCMS && contents && title_contents && (
            <>
              <DynamicAccordion
                contents={contents}
                title_contents={title_contents}
              />
            </>
          )}
          {!isCMS && !isPosVenda && !isAgendamento && !isPecas && <ChatBot />}
          {isPosVenda && <ChatManager />}
          {isAgendamento && <ChatManager />}
        </div>
      )}
    </>
  );
}
